import React, { Component } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, getStrokeColor, kmFormatter } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class ChannelBarChart extends Component {
    state = {};
    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    formatEngagementData(data) {
        let res = [];
        let total = Object.values(data)
            .map((x) => x.total)
            .reduce((x, y) => x + y, 0);
        for (let platform in data) {
            let platformName = this.props.allPlatforms.find((plt) => plt.id === platform);
            let short_name = platformName ? platformName.short_name : "";
            platformName = platformName ? platformName.name : "";
            let Engagements = data[platform].total;
            let percentage = ((data[platform].total / total) * 100).toFixed(2);
            let color = getStrokeColor(short_name);
            res.push({
                percent: percentage,
                color: color,
                engagements: Engagements,
                name: platformName,
                platformId: platform,
                totalVal: total,
                dataLabels: {
                    inside: false,
                    x: 10,
                },

                data: [{ name: platformName, y: Engagements, percent: percentage, totalVal: total, platformId: platform }],
            });
        }
        res = res && res.sort((a, b) => b.engagements - a.engagements);
        return res;
    }

    getOptions = () => {
        const data = this.formatEngagementData(this.props.data);
        // console.log(this.props.data);
        // console.log(data);

        let self = this;
        const options = {
            chart: {
                type: "bar",
                spacingLeft: 10,
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: " ",
            },
            credits: {
                enabled: false,
            },

            xAxis: {
                type: "category",

                lineWidth: 1,
                labels: {
                    style: {
                        color: this.props.insights__recommendation ? "white" : "#333333",
                    },
                },
            },

            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                labels: {
                    style: {
                        color: this.props.insights__recommendation ? "white" : "#333333",
                    },
                },
            },
            legend: {
                enabled: this.props.showLegendBar,
                width: "20%",
                layout: "vertical",
                align: "right",
                padding: 3,
                // symbolPadding: 25,
                // x: -10,
                // y: 30,
                // backgroundColor: "white",
                // borderWidth: 1,
                // floating: true,
                itemMarginTop: 3,
                itemMarginBottom: 3,
                verticalAlign: "middle",
                labelFormatter: function () {
                    return `<p>${this.name}</p><br/>`;
                },
                /* eslint-disable */
            },

            series: data,
            plotOptions: {
                series: {
                    pointWidth: 15,
                    stacking: "normal",
                    events: {
                        legendItemClick: function () {
                            if (this.visible) {
                                this.setData([], false);
                            } else {
                                this.setData(data[this.index].data, false);
                            }
                        },
                    },
                },
                bar: {
                    borderWidth: 0,
                    dataLabels: {
                        inside: false,
                        enabled: this.props.showLabel,
                        color: this.props.insights__recommendation ? "white" : undefined,

                        formatter: function () {
                            return `<span>${kmFormatter(this.point.y)}</span>
                            `;
                        },
                        style: {
                            textOutline: "none",
                            color: "#333333",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener ? self.props.addContextMenuListener(e.x, e.y, this) : null;
                            },
                        },
                    },
                },
            },
            // tooltip: {
            //     outside: true,
            //     backgroundColor: "#fff",
            //     borderRadius: 6,
            // },
            tooltip: {
                //valueSuffix: "%",
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> <span>Impact Score |  <b>${this.point.percent}% | </b>
                   <span> <b>${numberWithCommas(this.point.y)}</b> / <b>${numberWithCommas(this.point.totalVal)}</b></span>
                    </span>`;
                },
            },
        };

        return options;
    };

    render() {
        return (
            <HighchartsReact
                ref={this.chartComponent}
                highcharts={Highcharts}
                options={this.getOptions()}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default ChannelBarChart;
